import React from "react";
import presizeAudTar from "../../assets/images/hospitality/precise-audi-targ.png";
import leadCapture from "../../assets/images/hospitality/leadCapture.png";
import multiChannel from "../../assets/images/hospitality/multi-chennal.png";
import automatedEmailCamp from "../../assets/images/hospitality/automated-email-camp.png";
import dynamicContentPers from "../../assets/images/hospitality/dynamic-content-perso.png";
import leadScoringPers from "../../assets/images/hospitality/leadScoringpers.png";
import onlineAdvert from "../../assets/images/hospitality/online-advert.png";
import socialMediaEngage from "../../assets/images/hospitality/socialMediaEngage.png";
import realTimeAna from "../../assets/images/hospitality/realTimeAna.png";

const features = [
  {
    title: "Precision Audience Targeting",
    desc: "BeyondLeadz allows you to segment your audience based on specific criteria such as booking history, guest preferences, and geographic location. By targeting these segments with tailored campaigns, you can increase the relevance of your messaging and boost engagement.",
    img: presizeAudTar,
  },
  {
    title: "Integrated Lead Capture from Booking Platforms",
    desc: "Capture leads directly from popular booking sites like MakeMyTrip, TripAdvisor, Hotels.com, and Booking.com. BeyondLeadz automatically integrates these leads into your marketing database, enabling you to follow up with personalized offers and promotions.",
    img: leadCapture,
  },
  {
    title: "Multi-Channel Campaign Management",
    desc: "Launch and manage marketing campaigns across various channels, including email, social media, and SMS. BeyondLeadz ensures consistent messaging across all platforms, helping you reach potential guests wherever they are most active.",
    img: multiChannel,
  },
  {
    title: "Automated Email Campaigns",
    desc: "Set up automated email workflows to nurture leads throughout their decision-making process. From welcome emails to post-stay follow-ups, BeyondLeadz enables you to stay connected with your guests, increasing the likelihood of repeat bookings.",
    img: automatedEmailCamp,
  },
  {
    title: "Dynamic Content Personalization",
    desc: "Leverage guest data to create personalized content and offers that resonate with individual preferences. Whether it’s a special discount for a returning guest or a tailored package for a honeymoon couple, BeyondLeadz helps you deliver messages that drive conversions.",
    img: dynamicContentPers,
  },
  {
    title: "Lead Scoring and Prioritization",
    desc: "Use lead scoring to identify and prioritize high-potential guests. BeyondLeadz automatically assigns scores based on interactions and behaviors, ensuring your marketing and sales efforts are focused on leads with the highest likelihood of booking.",
    img: leadScoringPers,
  },
  {
    title: "Online Advertising Integration",
    desc: "Integrate BeyondLeadz with your Google Ads, Facebook, and Instagram campaigns to capture leads from paid advertising. Track the effectiveness of your ads in real-time and adjust your strategies to maximize ROI.",
    img: onlineAdvert,
  },
  {
    title: "Social Media Engagement",
    desc: "Engage with potential guests on social media platforms like Facebook and Instagram. BeyondLeadz helps you monitor interactions, respond to inquiries, and capture leads directly from social channels, turning social engagement into tangible bookings.",
    img: socialMediaEngage,
  },
  {
    title: "Real-Time Analytics and Reporting",
    desc: "Access detailed reports on campaign performance, lead generation, and booking conversions. BeyondLeadz provides you with the insights needed to refine your marketing strategies, optimize your lead generation efforts, and achieve better results.",
    img: realTimeAna,
  },
];

const FeaturesList = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-5xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-20">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Grow Direct Bookings
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Marketing and Lead Generation Solutions <br />
            for the <span className="tw-text-[#5D44FF]">Hospitality Industry</span>
          </h2>
        </div>

        {/* Alternating Layout Blocks */}
        <div className="tw-space-y-12">
          {features.map((item, idx) => {
            const isEven = idx % 2 === 0;
            return (
              <div
                key={idx}
                className="tw-bg-[#F8FCFF] tw-border tw-border-solid tw-border-slate-100 tw-rounded-[32px] tw-p-8 sm:tw-p-10 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-300"
              >
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-8 tw-items-center">
                  
                  {/* Text Container */}
                  <div className={`md:tw-col-span-7 tw-text-left ${isEven ? "md:tw-order-1" : "md:tw-order-2"}`}>
                    <div className="tw-inline-block tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-mb-3">
                      Solution 0{idx + 1}
                    </div>
                    <h3 className="tw-text-lg sm:tw-text-xl tw-font-extrabold tw-text-slate-800 tw-mb-4">
                      {item.title}
                    </h3>
                    <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                      {item.desc}
                    </p>
                  </div>

                  {/* Image Container */}
                  <div className={`md:tw-col-span-5 tw-flex tw-justify-center ${isEven ? "md:tw-order-2" : "md:tw-order-1"}`}>
                    <div className="tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-p-2 tw-border tw-border-solid tw-border-slate-100 tw-shadow-sm hover:tw-scale-[1.03] tw-transition-transform tw-duration-300">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="tw-max-w-full tw-h-auto tw-object-contain tw-rounded-lg"
                        loading="lazy"
                      />
                    </div>
                  </div>

                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default FeaturesList;
